"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalLinkIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.25 0h-8a.74.74 0 0 0-.69.47.74.74 0 0 0 .16.81L18 4.51l-9.45 9.3a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .7-.28l9.48-9.33 3.29 3.24a.74.74 0 0 0 .53.22.72.72 0 0 0 .29-.06.74.74 0 0 0 .45-.69V.75a.76.76 0 0 0-.75-.75Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.5 10.62a1 1 0 0 0-1 1V22H2V6.5h10.37a1 1 0 0 0 0-2H1.87A1.87 1.87 0 0 0 0 6.37v15.75A1.88 1.88 0 0 0 1.87 24h15.75a1.88 1.88 0 0 0 1.88-1.88v-10.5a1 1 0 0 0-1-1Z"
  }));
};
ExternalLink.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const ExternalLinkIcon = exports.ExternalLinkIcon = (0, _createIconComponent.default)(ExternalLink, 'ExternalLink');